/** Acesso estático — Metro só embute EXPO_PUBLIC_* assim (não usar process.env[key]). */
const REQUIRED_PUBLIC_ENV = [
  {
    key: 'EXPO_PUBLIC_API_URL',
    label: 'URL da API',
    value: process.env.EXPO_PUBLIC_API_URL,
  },
  {
    key: 'EXPO_PUBLIC_SUPABASE_URL',
    label: 'URL do Supabase',
    value: process.env.EXPO_PUBLIC_SUPABASE_URL,
  },
  {
    key: 'EXPO_PUBLIC_SUPABASE_ANON_KEY',
    label: 'chave anônima do Supabase',
    value: process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY,
  },
] as const;

export function getMissingPublicEnvKeys(): string[] {
  return REQUIRED_PUBLIC_ENV.filter(({ value }) => !value?.trim()).map(({ key }) => key);
}

export function getMissingPublicEnvDetails(): { key: string; label: string }[] {
  return REQUIRED_PUBLIC_ENV.filter(({ value }) => !value?.trim()).map(({ key, label }) => ({
    key,
    label,
  }));
}

export function isPublicEnvConfigured(): boolean {
  return getMissingPublicEnvKeys().length === 0;
}

export function getPublicEnvConfigError(): string | null {
  const missing = getMissingPublicEnvDetails();
  if (missing.length === 0) return null;

  const list = missing.map(({ key, label }) => `• ${key} — ${label}`).join('\n');

  return `Variáveis ausentes neste build:\n${list}\n\nSe já aparecem no EAS (eas env:list --environment production), gere um novo build e reinstale no TestFlight — builds antigos não pegam env atualizada.`;
}
